import React from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";

import { requestNewDueDate } from "../../redux/requestDueDate/requestNewDueDateActions";
import RequestDueDateModal from "./requestDueDateModal";

/*
    controls to display a modal form used to request a new due date for a
    work order.
    props:
        - workOrder: {}
        - show: () => void
        - close: () => void
        reasons: array of reasons for the extension
        subreasons: array of subreasons for the extension
        requetNewDueDate: (requestInfo) => void
            callback used to make the request for extension
*/
export const RequestDueDate = (props) => {
    const submitRequest = (requestInfo) => {
        props.requestNewDueDate(requestInfo);
        props.close();
    };

    return (
        <React.Fragment>
            <RequestDueDateModal
                id="due-date-RDD-modal"
                show={props.show}
                workOrder={props.workOrder}
                onAccept={submitRequest}
                onCancel={() => props.close()}
                reasons={props.reasons}
                subreasons={props.subreasons}
            />
        </React.Fragment>
    );
};

const mapStateToProps = (state) => {
    return {
        reasons: state.reasons.partialReasons.has("RAP") ? state.reasons.partialReasons.get("RAP").filter((reason) => !reason.parentReasonCode) : [],
        subreasons: state.reasons.partialReasons.has("RAP")
            ? state.reasons.partialReasons.get("RAP").filter((reason) => reason.parentReasonCode)
            : [],
    };
};

const mapDispatchToProps = (dispatch) =>
    bindActionCreators(
        {
            requestNewDueDate,
        },
        dispatch,
    );

export default connect(mapStateToProps, mapDispatchToProps)(RequestDueDate);
